import React from 'react'
import './TabNav.sass'
import { Link, withRouter } from 'react-router-dom'

function TabNav({ links = [], buttons = null, location }) {
  return (
    <div className="TabNav">
      <div className="TabNavLinks">
        {links.map((l) => {
          const isActive = location.pathname === l.path || location.pathname.startsWith(`${l.path}/`)

          return (
            <Link
              key={l.path}
              className={`TabNavLink ${isActive ? 'TabNavLink_active' : ''}`.trim()}
              to={l.path}
              target={l.target}
              rel={l.target === '_blank' ? 'noopener noreferrer' : undefined}
            >
              {l.title}
            </Link>
          )
        })}
      </div>
      <div className="TabNavButtons">{buttons}</div>
    </div>
  )
}

export default withRouter(TabNav)
